import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "./../assets/scss/requisition/index.scss";

import { confirmable, createConfirmation } from "react-confirm";
import { ApproveModalIcon, BookIcon, RecieptIcon } from "./Icons";
import { useBackendUrl } from "../utils/hooks";

function Dialog({
  proceed,
  show,
  title = "",
  description = "",
  InvoiceNo,
  useAPI,
}) {
  const backendUrl = useBackendUrl();
  return (
    <Modal
      show={show}
      onHide={() => proceed(false)}
      dialogClassName="requisition-details-modal"
      centered={true}
      animation={false}
      enforceFocus={false}
    >
      <Modal.Header closeButton />
      <Modal.Body className="approve-action">
        <div className="text-info-h">
          <ApproveModalIcon className="mb-4" />
          <h2>{title}</h2>
          <p
            className="fs-6"
            dangerouslySetInnerHTML={{ __html: description }}
          />
        </div>
        <section className="row flex-wrap gap-4 px-3 mt-4">
          <a
            as="a"
            href={
              useAPI
                ? `${useAPI}/${InvoiceNo}`
                : `${backendUrl}/api/reports/pdf/grn/${InvoiceNo}`
            }
            target="blank"
            className="btn btn-primary p-3 col-12"
            //  disabled={isEmpty(TransactionID)}
          >
            Print GRN
          </a>
        </section>
      </Modal.Body>
    </Modal>
  );
}

export default function GRNDialog(props) {
  return createConfirmation(confirmable(Dialog))(props);
}
